import config from "appConfig";
import { LayoutComponent } from "@jelly/lesson";

const component: LayoutComponent[] = [
  {
    variant: "layout",
    data: {
      type: "table",
      options: {
        cols: 1,
        rows: 2,
        rowsSize: [4, 1],
        components: [
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/01/22/principle/house-interior.png`,
                  },
                },
              },
            },
          ],
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "audioButton",
                  options: {
                    text: "play sound",
                    theme: "primary",
                    icon: "cis-volume-high",
                    shape: "round",

                    url: `${config.ASSETS_URL}/01/22/principle/house-interior.wav`,
                  },
                },
              },
            },
          ],
        ],
      },
    },
  },
];

export default component;
